import type { IconProps } from './IconProps';

export const SwapIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1362 1.46967C10.4291 1.17678 10.9039 1.17678 11.1968 1.46967L13.8635 4.13634C14.1564 4.42923 14.1564 4.9041 13.8635 5.197L11.1968 7.86366C10.9039 8.15656 10.4291 8.15656 10.1362 7.86366C9.84328 7.57077 9.84328 7.0959 10.1362 6.803L11.5225 5.41667H2.6665C2.25229 5.41667 1.9165 5.08088 1.9165 4.66667C1.9165 4.25245 2.25229 3.91667 2.6665 3.91667H11.5225L10.1362 2.53033C9.84328 2.23744 9.84328 1.76256 10.1362 1.46967ZM5.8635 8.13634C6.15639 8.42923 6.15639 8.9041 5.8635 9.197L4.47716 10.5833H13.3332C13.7474 10.5833 14.0832 10.9191 14.0832 11.3333C14.0832 11.7475 13.7474 12.0833 13.3332 12.0833H4.47716L5.8635 13.4697C6.15639 13.7626 6.15639 14.2374 5.8635 14.5303C5.57061 14.8232 5.09573 14.8232 4.80284 14.5303L2.13617 11.8637C1.84328 11.5708 1.84328 11.0959 2.13617 10.803L4.80284 8.13634C5.09573 7.84344 5.57061 7.84344 5.8635 8.13634Z"
      fill="currentColor"
    />
  </svg>
);
